import { API_HOST_NAME } from "../../constants.js"
import useAuthenticatedResources from "../../../../useAuthenticatedResources.js"

const useTeamIngressControllersResources = (teamId) => {
  const url = `${API_HOST_NAME}/api/v1/admin/teams/${teamId}/docker/ingress_controllers`
  return useAuthenticatedResources(url)
}

export default useTeamIngressControllersResources
